import { PlaceholdersId, TFComponent } from '@types';
import { SummaryNextStepsPlaceholder } from './summaryNextSteps';

export const summaryNextSteps: TFComponent = {
	component: SummaryNextStepsPlaceholder,
	id: PlaceholdersId.summaryNextSteps,
	name: 'summaryNextSteps',
};
